//Common functions that many components use
//Helpers
function getMonthsInbetween(startMonth, endMonth) {
	var monthNames = [
		'Januari',
		'Februari',
		'Mars',
		'April',
		'Maj',
		'Juni',
		'Juli',
		'Augusti',
		'September',
		'Oktober',
		'November',
		'December',
	];

	const months = [];
	const low = monthNames.indexOf(startMonth);
	const high = monthNames.indexOf(endMonth);
	for (let i = low; i <= high; i++) {
		months.push(monthNames[i]);
	}
	return months;
}
//Dom updater
function updateMonthSelect() {
	//If last element is year select, check how many months to add
	var months = [],
		data = [];
	if (!this.storedData.dates) return console.error('NO DATES');

	if (this.storedData.dates.startMonth && this.storedData.dates.endMonth) {
		if (
			this.selectors['yearSelect'].selectorObj.value ==
			this.storedData.dates.endYear
		) {
			months = getMonthsInbetween(
				'Januari',
				this.storedData.dates.endMonth
			);
		} else if (
			this.selectors['yearSelect'].selectorObj.value ==
			this.storedData.dates.startYear
		) {
			months = getMonthsInbetween(
				this.storedData.dates.startMonth,
				'December'
			);
		} else {
			months = getMonthsInbetween('Januari', 'December');
		}
	} else {
		months = getMonthsInbetween(
			'Januari',
			this.storedData.dates.months[
			this.storedData.dates.months.length - 1
			]
		);
	}
	for (var j = 0; j < months.length; j++) {
		data.push(months[j]);
	}
	this.addDataToSelect('monthSelect', data);
}
//Dom updater
function updateMonthSelectWithFullyear() {
	//If last element in year select, check how many months to add
	var months,
		data = [];
	if (!this.storedData.dates) return console.error('NO DATES');
	if (
		this.selectors['yearSelect'].selectorObj.selectedIndex ===
		this.selectors['yearSelect'].selectorObj.length - 1
	) {
		if (
			this.storedData.dates.startMonth &&
			this.storedData.dates.endMonth
		) {
			months = getMonthsInbetween(
				this.storedData.dates.startMonth,
				this.storedData.dates.endMonth
			);
		} else
			months = getMonthsInbetween(
				'Januari',
				this.storedData.dates.months[
				this.storedData.dates.months.length - 1
				]
			);
	}
	//If element is the first one, we have to check startMonth
	else if (this.selectors['yearSelect'].selectorObj.selectedIndex === 0) {
		if (this.storedData.dates.startMonth) {
			months = getMonthsInbetween(
				this.storedData.dates.startMonth,
				'December'
			);
		} else
			months = getMonthsInbetween(
				this.storedData.dates.months[0],
				'December'
			);
	} else {
		months = getMonthsInbetween('Januari', 'December');
	}
	for (var j = 0; j < months.length; j++) {
		data.push(months[j]);
	}
	data.unshift({
		name: 'Helår',
		value: 'Helår',
	});
	this.addDataToSelect('monthSelect', data);
}

function updateUnitSelect(
	defaultUnit = 'Alla vårdcentraler',
	unitObjectName = 'units'
) {
	var regionSelect = this.selectors['regionSelect'];
	var currValue = regionSelect.selectorObj.value;
	var disable = true;
	var dataToAdd = [{ name: defaultUnit, value: -1 }];
	if (currValue.toString() !== '-1') {
		for (var i = 0; i < regionSelect.data.length; i++) {
			if (
				regionSelect.data[i].value.toString() ===
				currValue.toString() &&
				regionSelect.data[i][unitObjectName]
			) {
				for (
					var j = 0;
					j < regionSelect.data[i][unitObjectName].length;
					j++
				) {
					dataToAdd.push(regionSelect.data[i][unitObjectName][j]);
				}
				disable = false;
			}
		}
	}
	if (disable)
		this.selectors['unitSelect'].selectorObj.setAttribute(
			'disabled',
			disable
		);
	else this.selectors['unitSelect'].selectorObj.removeAttribute('disabled');
	this.addDataToSelect('unitSelect', dataToAdd);
}
function updateMultiUnitSelect() {
	var regionSelect = this.selectors['regionSelect'];
	var currValue = regionSelect.selectorObj.value;
	var disable = true;
	var dataToAdd = [];
	for (var i = 0; i < regionSelect.data.length; i++) {
		//Find
		//If more than 1 region selected, disable
		if (currValue.length > 1) {
			disable = true;
		} else {
			if (
				regionSelect.data[i].value === currValue[0] &&
				regionSelect.data[i].units
			) {
				for (var k = 0; k < regionSelect.data[i].units.length; k++) {
					dataToAdd.push(regionSelect.data[i].units[k]);
				}
				disable = false;
			}
		}
	}
	this.selectors['unitSelect'].selectorObj.setAttribute('disabled', disable);

	this.addDataToSelect('unitSelect', dataToAdd);
}

function updateMultiUnitAndClinicSelect(regionSelect) {
	const currValue = regionSelect.selectorObj.value;
	const result = {
		unitData: [],
		clinicData: [],
	};
	for (var i = 0; i < regionSelect.data.length; i++) {
		//Find
		//If more than 1 region selected or none selected, return empty
		if (currValue.length !== 1) {
			return result;
		}
		if (
			regionSelect.data[i].value === currValue[0] &&
			regionSelect.data[i].units &&
			regionSelect.data[i].clinics
		) {
			result.unitData = regionSelect.data[i].units;
			result.clinicData = regionSelect.data[i].clinics;
		}
	}
	return result;
}

function updateMunicipalitySelect() {
	var countySelect = this.selectors['countySelect'];
	var currValue = countySelect.selectorObj.value;
	var disable = true;
	var dataToAdd = [{ name: 'Alla kommuner', value: -1 }];
	if (currValue.toString() !== '-1') {
		for (var i = 0; i < countySelect.data.length; i++) {
			if (
				countySelect.data[i].value.toString() ===
				currValue.toString() &&
				countySelect.data[i].municipalities
			) {
				for (
					var j = 0;
					j < countySelect.data[i].municipalities.length;
					j++
				) {
					dataToAdd.push(countySelect.data[i].municipalities[j]);
				}
				disable = false;
			}
		}
	}
	if (disable)
		this.selectors['municipalitySelect'].selectorObj.setAttribute(
			'disabled',
			disable
		);
	else
		this.selectors['municipalitySelect'].selectorObj.removeAttribute(
			'disabled'
		);
	this.addDataToSelect('municipalitySelect', dataToAdd);
}

function numberWithThousandSeparator(value) {
	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}


export {
	getMonthsInbetween,
	updateUnitSelect,
	updateMultiUnitSelect,
	updateMultiUnitAndClinicSelect,
	updateMonthSelect,
	updateMunicipalitySelect,
	numberWithThousandSeparator,
	updateMonthSelectWithFullyear,
};
